const ORIGINALPARAM = {
  token: 'ab527m34e8omaeb6vh29voe5p6',
  v: '1.0.0',
  t: ''
}

export default ORIGINALPARAM;
